import React from "react";

interface DeleteIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const DeleteIcon: React.FC<DeleteIconProps> = ({
  className = "",
  width = 16,
  height = 16,
  fill = "#4F4A4A",
  onClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M10.6663 6V12.6667H5.33301V6H10.6663ZM9.66634 2H6.33301L5.66634 2.66667H3.33301V4H12.6663V2.66667H10.333L9.66634 2ZM11.9997 4.66667H3.99967V12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V4.66667Z"
        fill={fill}
      />
    </svg>
  );
};

export default DeleteIcon;
